import type * as api from '@gitbook/api-client';
import * as analytics from '@gitbook/app-analytics/client';
import { confirm, toast } from '@gitbook/spine-react';

import type { NavigateFunction } from '../../navigation';
import { apiClient, apiQuery, apiQueryClient } from '../../state';

export interface ConfirmOpenAPISpecDeleteProps {
    organizationId: string;
    openAPISpec: api.OpenAPISpec;
    navigate: NavigateFunction;
}
/**
 * Open a confirmation dialog to delete an OpenAPI specification.
 */
export function confirmOpenAPISpecDelete(props: ConfirmOpenAPISpecDeleteProps) {
    const { organizationId, openAPISpec, navigate } = props;

    return confirm({
        title: 'Delete OpenAPI specification',
        description: 'All content associated with this OpenAPI specification will be inaccessible.',
        confirmLabel: 'Delete',
        kind: 'danger',
        onConfirm: async () => {
            await toast.catch(async () => {
                await apiClient.openapi.deleteOpenApiSpecBySlug(organizationId, openAPISpec.slug);
                analytics.logEvent({
                    type: 'openapi_spec_delete',
                    organization: organizationId,
                    specSlug: openAPISpec.slug,
                });
                // Be sure to reset query to avoid any blinking
                // and stale data.
                await apiQueryClient.resetQueries({
                    queryKey: apiQuery('getOpenAPISpecBySlug', {
                        organizationId,
                        specSlug: openAPISpec.slug,
                    }).queryKey,
                });
                navigate({
                    screen: {
                        type: 'openapi_specs',
                        organization: organizationId,
                    },
                });
                toast.success('OpenAPI specification deleted');
            }, 'Error while deleting OpenAPI specification');
        },
    });
}
